export const environment = {
  production: true,
  hmr: false,
  mapsApiKey: 'AIzaSyATXeO9KmbGd0OLgAFYK6boynAFEvrAgYk',
};
